<template>
<div>
  <div v-show="errors.has(inputname)" class="invalid-feedback">Enter a valid time</div>

  <vue-suggest
    :list="simpleSuggestionList"
    :filter-by-query="true"
    :max-suggestions="100"
    :min-length="0"
    :prevent-submit="true"
    v-model="editData.time"
    @input="valueUpdated($event)"
    >
    <input
          :name="inputname"
          v-validate.initial="validations"
          class="form-control gl-time-suggest-input"
          v-model="editData.time"
          >

  </vue-suggest>
  </div>
</template>

<script>
  import VueSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css'
  import _ from 'lodash'

  export default {
    name: 'GLTimeSuggest',
    inject: ['$validator'],
    components: {
      VueSuggest
    },
    props: {
      value: {
        type: String
      },
      inputname: {
        type: String
      },
      validations: {
        type: String,
        default: 'date_format:h:mma|required'
      }
    },
    data () {
      return {
        editData: {
          time: '9:00am'
        }
      }
    },
    created: function () {
      this.editData.time = this.value
    },
    watch: {
      value: function (newValue, oldValue) {
        this.editData.time = newValue
      }
    },
    methods: {
      simpleSuggestionList () {
        return [
          '12:00am',
          '12:30am',
          '1:00am',
          '1:30am',
          '2:00am',
          '2:30am',
          '3:00am',
          '3:30am',
          '4:00am',
          '4:30am',
          '5:00am',
          '5:30am',
          '6:00am',
          '6:30am',
          '7:00am',
          '7:30am',
          '8:00am',
          '8:30am',
          '9:00am',
          '9:30am',
          '10:00am',
          '10:30am',
          '11:00am',
          '11:30am',
          '12:00pm',
          '12:30pm',
          '1:00pm',
          '1:30pm',
          '2:00pm',
          '2:30pm',
          '3:00pm',
          '3:30pm',
          '4:00pm',
          '4:30pm',
          '5:00pm',
          '5:30pm',
          '6:00pm',
          '6:30pm',
          '7:00pm',
          '7:30pm',
          '8:00pm',
          '8:30pm',
          '9:00pm',
          '9:30pm',
          '10:00pm',
          '10:30pm',
          '11:00pm',
          '11:30pm'
        ]
      },
      valueUpdated (val) {
        this.$emit('input', _.cloneDeep(val))
      }
    }
  }
</script>

<style>
.vue-simple-suggest.designed .suggestions {
  height: 300px;
  overflow: scroll;
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
}
.invalid-feedback {
  color: rgba(210,0,0,1.0);
}
</style>



// WEBPACK FOOTER //
// gl-timesuggest.vue?122c8bba